module.exports = __webpack_public_path__ + "img/keadsAndYoughth.948621ff.png";